import {getUserProfile} from './mailbox'
import {USER_PREFERENCE_STORAGE_KEY_PREFIX, USER_PREFERENCE_REPORT_PHISHING_EMAIL_PROP, USER_PREFERENCE_SHOW_ANALYSIS_PROP} from './constants'

//*********************************************************************
// Private functions for handling local storage updates
//*********************************************************************

/*
    Detects whether localStrorage is both supported and available
    https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
*/
function storageAvailable(type = 'localStorage') {
  var storage;
  try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
  }
  catch(e) {
      return e instanceof DOMException && (
          // everything except Firefox
          e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          (storage && storage.length !== 0);
  }
}

/*
    If a key is supplied, returns a specific property from the UserPreferences local storage object,
    else, returns the entire UserPreferences local storage object.
*/
function getUserPreferencesFromLocalStorage(key){
  if(!storageAvailable()) {
    return;
  }
  const userPreferencesKey = getUserPreferencesKey();
  const userPreferences = JSON.parse(window.localStorage.getItem(userPreferencesKey));
  if(userPreferences){
    if(key){
        return userPreferences[key];
    }
    return userPreferences;  
  }
}

/*
    Creates/Updates the UserPreferences local storage object for the current user
*/
function setUserPreferencesToLocalStorage(key, value){
  if(!storageAvailable()) {
    return;
  }
  const userPreferencesKey = getUserPreferencesKey();
  const userPreferences = getUserPreferencesFromLocalStorage() || {};
  userPreferences[key] = value;
  window.localStorage.setItem(userPreferencesKey, JSON.stringify(userPreferences));
}



//*********************************************************************
//Public functions for getting specific local storage object properties
//*********************************************************************


export function getReportPhishingToEmail(){
    return getUserPreferencesFromLocalStorage(USER_PREFERENCE_REPORT_PHISHING_EMAIL_PROP);
}

export function setReportPhishingToEmail(value){
    return setUserPreferencesToLocalStorage(USER_PREFERENCE_REPORT_PHISHING_EMAIL_PROP, value)
}


export function getShowAnalysisPreference(){
  return getUserPreferencesFromLocalStorage(USER_PREFERENCE_SHOW_ANALYSIS_PROP);
}

export function setShowAnalysisPreference(value){
  return setUserPreferencesToLocalStorage(USER_PREFERENCE_SHOW_ANALYSIS_PROP, value)
}

export function getUserPreferencesKey(){
  const userProfile = getUserProfile();
  return USER_PREFERENCE_STORAGE_KEY_PREFIX+userProfile.emailAddress;
}